import React from 'react';
import './App.css';
import LowFiveRouter from "./app/auth/LowFiveRouter";

function App() {
    return (
        <LowFiveRouter/>
    );
}

export default App;
